import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { careerEntries } from '../data/career';
const section = sections[6];
export function Career() {
  return <div data-id="element-126" data-mp="2l8mkrv5ar8j6">
      <PageHeader section={section} intro="Executive line roles held at director level in United Kingdom central government, in sequence from most recent." data-id="element-127" data-mp="2l8e8o5h00791" />

      <ol className="mt-12 border-l border-slate-300 pl-8 sm:pl-12" data-id="element-128" data-mp="3cz0tlcygdunz">
        {careerEntries.map((entry, i) => <li key={entry.title} className={i === careerEntries.length - 1 ? 'relative' : 'relative pb-14'} data-id="element-129" data-mp="38ygwg9dvqr1u" data-mpi={i}>
            <span aria-hidden="true" className="absolute -left-[38px] top-2 h-2.5 w-2.5 rotate-45 border border-gold bg-bone sm:-left-[54px]" data-id="element-130" data-mp="3444de0gbfhqm" />
            <p className="text-[10px] font-semibold uppercase tracking-overline text-gold-dark" data-id="element-131" data-mp="jgon122if5k">
              {entry.period}
            </p>
            <h2 className="mt-3 font-serif text-2xl leading-tight text-navy" data-id="element-132" data-mp="x5h83iroou2q">
              {entry.title}
            </h2>
            <p className="mt-1.5 text-sm font-semibold text-slateink" data-id="element-133" data-mp="123r1poxrfmm8">
              {entry.organisation}
            </p>
            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-slateink" data-id="element-134" data-mp="odf8fmpfvhti">
              {entry.summary}
            </p>

            <ul className="mt-6 grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2" data-id="element-135" data-mp="efhlr3n89t30">
              {entry.achievements.map(achievement => <li key={achievement} className="bg-white p-5 text-[13px] leading-relaxed text-slateink" data-id="element-136" data-mp="jg5kkbhp7e7s">
                  {achievement}
                </li>)}
            </ul>
          </li>)}
      </ol>
    </div>;
}